// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { FacilityEvent, IFacilityEvent } from "./FacilityEvent.gen";

export interface IFacilityEventResult {
	data: IFacilityEvent[] | undefined;

	hasMore: boolean;

	nextCursor: string | undefined;

	count: number;

	$type?: string | undefined;
}
export class FacilityEventResult {
	constructor(data?: IFacilityEventResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.data = data.data ? data.data.map((d: any) => new FacilityEvent(d)) : [];
	}

	data: FacilityEvent[] | undefined = [];

	hasMore: boolean = false;

	nextCursor: string | undefined;

	count: number = 0;

	static $type: string = "CoreApi.Models.Pagination.FacilityEventResult, ";
	$type?: string | undefined = FacilityEventResult.$type;
}

